import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true // 👈 Enable CSS variables
    },
    themes: {
      light: {
        primary: '#5ad00c',
        error: '#b71c1c',
        background: '#f7f7f7', // สีพื้นหลังของ Light Mode
        surface: '#ffffff',
        text: '#000000'
      },
      dark: {
        primary: '#5ad00c',
        error: '#b71c1c',
        background: '#121212', // สีพื้นหลังของ Dark Mode
        surface: '#1e1e1e',
        text: '#ffffff'
      }
    }
  }
})

Vue.use(Vuetify)

export default vuetify
